import { API_ROOT } from "config.js";
// import { MQTT_SERVER_ROOT, API_ROOT } from "config.js";

const DEVICE_LIST_ENDPOINT = `${API_ROOT}/api/devices/`;
const DEVICE_DETAILS_ENDPOINT = `${API_ROOT}/api/device/`;

// const CLIENTS_LIST_ENDPOINT = `${MQTT_SERVER_ROOT}/clients/`;
// const PUBLISH_COMMAND_ENDPOINT = `${MQTT_SERVER_ROOT}/publish/`;

export async function getDeviceConfig(axios, deviceId) {
  let url = `${DEVICE_LIST_ENDPOINT}`;
  if (deviceId !== undefined) {
    url = `${DEVICE_DETAILS_ENDPOINT}config/${deviceId}`;
  }
  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function getDeviceCommands(
  axios,
  deviceId,
  page = 0,
  rowsPerPage = 10
) {
  let url = `${DEVICE_LIST_ENDPOINT}`;
  if (deviceId !== undefined) {
    url = `${DEVICE_DETAILS_ENDPOINT}commands/${deviceId}?page=${page}&page_size=${rowsPerPage}`;
  }
  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function createDeviceCommand(axios, deviceId, commandData) {
  let payload = commandData;
  let url = `${DEVICE_DETAILS_ENDPOINT}sendcommand/${deviceId}`;
  const response = await axios.post(url, payload);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}
